module.exports = __webpack_public_path__ + "img/download_on_the_App_Store.1b659262.svg";